export default __webpack_public_path__ + "static/media/Create-documentation.c3d44287.md";